import { Component, Input } from '@angular/core';
import { EmployeeGroupChangeRequestDTO, EmployeeOverviewView } from '@iota/inh-core-v1-management-client';

@Component({
    standalone: false,
    selector: 'app-employee-group-change-dialog-validation-data',
    templateUrl: './employee-group-change-dialog-validation-data.component.html',
    styleUrls: ['./employee-group-change-dialog-validation-data.component.scss']
})
export class EmployeeGroupChangeDialogValidationDataComponent {
    @Input() groupChangeRequest: EmployeeGroupChangeRequestDTO;
    @Input() employee: EmployeeOverviewView;
    @Input() officeIdToNameMap: Map<string, string>;

    get employeeOfficeName() {
        return this.officeIdToNameMap?.get(this.employee?.officeId);
    }
}
